import { render, staticRenderFns } from "./ResourceDownload.vue?vue&type=template&id=27bc2a3a&scoped=true"
import script from "./ResourceDownload.vue?vue&type=script&lang=js"
export * from "./ResourceDownload.vue?vue&type=script&lang=js"
import style0 from "./ResourceDownload.vue?vue&type=style&index=0&id=27bc2a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc2a3a",
  null
  
)

export default component.exports